/* eslint-disable eqeqeq */
import { Box, Button, Divider, Grid, Paper, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { formatNumber, trimText } from "../../../../../utils";
import { getFiatFeeStructure, withdrawFiat, logEvent } from "../../../../../store/api";
import AppLoader from "../.../../../../../../components/AppLoader";
import { setLastRefId, showMessageBar } from '../../../../../store/actions';

import { useDispatch } from "react-redux";
import { ACTIVITY_DETAIL, EVENTS, MESSAGE_BAR_TYPES } from "../../../../../utils/constants";
import { useLocation, useNavigate } from "react-router-dom";
import AppScreenLoader from "../../../../../components/AppScreenLoader";
import AppToolTip from "../../../../../components/AppTooltip";
export default function PaymentSummary(props) {
    const { amount, country, destinationId, paymentCurrency,
        paymentMethod
    } = props;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [feestructure, setFeestructure] = useState({});
    const [loading, setLoading] = useState(false);
    const { t } = useTranslation();
    const location = useLocation();
    const [waitingText, setWaitingText] = useState("");

    useEffect(() => {
        getFeesData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    const getFeesData = async () => {
        try {
            const data = await getFiatFeeStructure({
                amount,
                currency: paymentCurrency,
                destinationRecordId: destinationId
            });
            setFeestructure(data.result);
        } catch (err) {
            dispatch(showMessageBar(MESSAGE_BAR_TYPES.ERROR, err))
        }
    };
    const handlePayment = async () => {
        setLoading(true);
        setWaitingText("Initiating Transfer ...")
        try {
            const payload = {
                amount,
                currency: paymentCurrency,
                destinationRecordId: destinationId
            }
            const data = await withdrawFiat(payload);
            logEvent({
                current: EVENTS.WITHDRAWAL.CONFIRM_FIAT_TRANSFER,
                activity: ACTIVITY_DETAIL.WITHDRAWAL.CONFIRM_FIAT_TRANSFER,
                meta: {
                    data: {
                        country: country.three_letter_code,
                        currency: paymentCurrency,
                        method: paymentMethod.displayName,
                        provider: destinationId,
                        pathname: location.pathname,
                        source: ACTIVITY_DETAIL.WITHDRAWAL.CONFIRM_FIAT_TRANSFER
                    }
                }
            });
            setLoading(false);
            setWaitingText("");
            dispatch(setLastRefId(data.result.id));
            navigate(`/withdraw/status/${data.result.id}`);
        } catch (err) {
            setLoading(false);
            setWaitingText("");
            dispatch(showMessageBar(MESSAGE_BAR_TYPES.ERROR, err))
        }
    }
    if (!Object.keys(feestructure).length) {
        return <AppScreenLoader />
    }
    return (<Paper
        sx={{
            backgroundColor: "transparent",
            boxShadow: "none",
            paddingTop: 4,
        }}
    >

        <Grid container sx={{ color: "#D6E3F0", margin: 0 }}>
            <Grid item xs={6}>
                <Typography
                    fontFamily={"Manrope"}
                    fontSize={14}
                    fontWeight={400}
                    textAlign="left"
                    textTransform="capitalize"
                    color="#D4D4D8"
                >
                    {t("Amount Requested")}:
                </Typography>
            </Grid>
            <Grid item xs={6}>
                <Typography
                    fontFamily={"Manrope"}
                    fontSize={14}
                    fontWeight={400}
                    textAlign="right"
                    textTransform="capitalize"
                    color="#D4D4D8"
                >
                    {formatNumber(amount)} USD
                </Typography>
            </Grid>
            <Grid item xs={6}>
                <Typography
                    fontFamily={"Manrope"}
                    fontSize={14}
                    textAlign="left"
                    fontWeight={400}
                    textTransform="capitalize"
                    color="#D4D4D8"
                >
                    {t("Currency requested")}:
                </Typography>
            </Grid>
            <Grid item xs={6}>
                <Typography
                    fontFamily={"Manrope"}
                    fontSize={14}
                    textAlign="right"
                    textTransform="uppercase"
                    fontWeight={400}
                    color="#D4D4D8"
                >
                    {paymentCurrency}
                </Typography>
            </Grid>
            <Grid item xs={6}>
                <Typography
                    fontFamily={"Manrope"}
                    fontSize={14}
                    textAlign="left"
                    fontWeight={400}
                    textTransform="capitalize"
                    color="#D4D4D8"
                >
                    {t("selectPaymentBack")}:
                </Typography>
            </Grid>
            <Grid item xs={6}>
                <Typography
                    fontFamily={"Manrope"}
                    fontSize={14}
                    textAlign="right"
                    textTransform="capitalize"
                    fontWeight={400}
                    color="#D4D4D8"
                >
                    {paymentMethod?.displayName}
                </Typography>
            </Grid>

            {!!feestructure?.feeEnabled && <> <Grid item xs={7}>
                <Typography
                    fontFamily={"Manrope"}
                    fontSize={14}
                    textAlign="left"
                    fontWeight={400}
                    textTransform="capitalize"
                    color="#D4D4D8"
                >
                    {t("processing-fee")}:
                </Typography>
            </Grid>
                <Grid item xs={5}>
                    <Typography
                        fontFamily={"Manrope"}
                        fontSize={14}
                        textAlign="right"
                        textTransform="uppercase"
                        fontWeight={400}
                        color="#D4D4D8"
                    >
                        {feestructure?.processingFeeFlatUsd ? `${feestructure?.processingFeeFlatUsd} USD` : ''}&nbsp;
                        {parseFloat(feestructure?.processingFeePercent?.toString()) != '0' ? `+ ${feestructure?.processingFeePercent}%` : ''}
                    </Typography>
                </Grid></>}
            <Grid item xs={12}>
                <Divider />
            </Grid>
            <Grid
                item
                xs={6}
                fontSize={14}
                textTransform="capitalize"
                color="#D4D4D8"
            >
                <Typography
                    fontFamily={"Manrope"}
                    fontSize={14}
                    textAlign="left"
                    textTransform="capitalize"
                    fontWeight={400}
                    color="#D4D4D8"
                >
                            {t("Amount To Be Sent")}:

                </Typography>
            </Grid>
            <Grid
                item
                xs={6}
                textAlign="right"
                fontSize={14}
                textTransform="capitalize"
                color="#D4D4D8"
            >
                <Typography
                    fontFamily={"Manrope"}
                    fontSize={14}
                    textAlign="right"
                    textTransform="uppercase"
                    fontWeight={400}
                    color="#D4D4D8"
                >
                    {feestructure?.payoutAmountUsd} USD
                </Typography>
            </Grid>

            <Grid item xs={6}>
                <Typography
                    fontFamily={"Manrope"}
                    fontSize={14}
                    textAlign="left"
                    textTransform="capitalize"
                    fontWeight={400}
                    color="#D4D4D8"
                >
                    {t("exchangeRate")}:
                </Typography>
            </Grid>


            <Grid item xs={6}>
                <Typography
                    fontFamily={"Manrope"}
                    fontSize={14}
                    textAlign="right"
                    textTransform="capitalize"
                    fontWeight={400}
                    color="#D4D4D8"
                >
                    <span>1 USD =  </span>
                    <AppToolTip
                        enterTouchDelay={0}
                        title={`${feestructure?.rkflRate?.toString()} ${feestructure?.currency}`}
                        placement="top" arrow>
                        <span>{trimText(feestructure?.rkflRate?.toString(), 6)}</span>
                    </AppToolTip>&nbsp;{feestructure?.currency}
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <Divider />
            </Grid>

            <Grid item xs={6}>
                <Typography
                    fontFamily={"Manrope"}
                    fontSize={14}
                    textAlign="left"
                    textTransform="capitalize"
                    fontWeight={400}
                    color="#D4D4D8"
                >
                    {t("AmountReceived")}:
                </Typography>
            </Grid>
            <Grid item xs={6}>
                <Box
                    display={"flex"}
                    flexDirection={"row"}
                    alignItems={"center"}
                    justifyContent={"flex-end"}
                >
                    <Typography
                        fontFamily={"Manrope"}
                        fontSize={24}
                        textAlign="right"
                        textTransform="uppercase"
                        fontWeight={400}
                        color="#D4D4D8"
                    >
                        {formatNumber(feestructure.payoutAmount || 0)} {feestructure.currency}
                    </Typography>
                    &nbsp;&nbsp;
                    {/* {feestructure?.payoutAmount && <Tooltip
                        title={t("approxDisclaimer")}
                        arrow
                        enterTouchDelay={0}
                    >
                        <Box
                            display={"flex"}
                            alignItems={"center"}
                            sx={{ cursor: "pointer" }}
                        >
                            <InfoOutlined />
                        </Box>
                    </Tooltip>} */}
                </Box>

            </Grid>
            <Grid item xs={12}>
                {waitingText && (
                    <Box
                        display={"flex"}
                        flexDirection="row"
                        alignItems={"center"}
                        marginTop={2}
                        sx={{
                            display: "flex",
                            flexFlow: "row",
                            alignItems: "center",
                            marginBottom: 2,
                        }}
                    >
                        <AppLoader
                            title={waitingText}
                            sx={{
                                display: "flex",
                                alignItems: "center",
                            }}
                            fontSize={16}
                        />
                    </Box>
                )}
            </Grid>

        </Grid>
        <Button
            variant="contained"
            size="large"
            color="primary"
            sx={{
                color: "#041939",
                marginTop: 10,
                fontSize: 16,
                width: "100%",
                textTransform: "capitalize",
                borderRadius: "8px",
                ":disabled": { backgroundColor: "#0088F5", opacity: 0.4 },
            }}
            disabled={!Object.keys(feestructure).length || loading}
            onClick={handlePayment}
        >
            {t("Confirm")}
        </Button>
    </Paper>)
}